import CountryLanding from "@/components/country/CountryLanding";
import { CHILE } from "@/data/countryPages";

export default function EOSChile() {
  return <CountryLanding country={CHILE} />;
}
